export const HEADER_ALERTS_BLOCK_RETRIEVE_CLASS = 'header-alerts__wrapper'
